// extracted by mini-css-extract-plugin
module.exports = {"head_text":"HeadText_head_text__C22c5","head_text_bg":"HeadText_head_text_bg__3yi1r"};